var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.622,
    height: 26.424,
    viewBox: "0 0 31.622 26.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 31.622,
    height: 26.424,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6768",
    "data-name": "Path 6768",
    d: "M24.591,23.131a19.371,19.371,0,0,1-2.9.12c-.517.006-1.035,0-1.552,0a1.057,1.057,0,1,1-.01-2.11c1.012,0,2.024,0,3.037,0a6.336,6.336,0,0,0,.895-12.619c-.218-.024-.438-.049-.656-.054a1.192,1.192,0,0,1-1.332-1.124A6.189,6.189,0,0,0,19.3,3.15,6.331,6.331,0,0,0,9.639,7.258c-.172.933-.469,1.185-1.412,1.209-.2.005-.394.03-.591.054a6.335,6.335,0,0,0-.435,12.5,9.4,9.4,0,0,0,1.807.123q1.271,0,2.543,0a1.058,1.058,0,1,1,.009,2.111c-.594,0-1.189,0-1.783,0a12.587,12.587,0,0,1-3.665-.327A8.45,8.45,0,0,1,7.248,6.445a.553.553,0,0,0,.541-.461,8.428,8.428,0,0,1,16.168.124.387.387,0,0,0,.391.33,8.449,8.449,0,0,1,.242,16.694",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6769",
    "data-name": "Path 6769",
    d: "M33.711,26.027A1.046,1.046,0,0,1,32.2,26.02q-1.583-1.567-3.151-3.149c-.084-.084-.154-.183-.23-.274l-.078.048V23q0,6.336,0,12.671a1.559,1.559,0,0,1-.045.49,1.052,1.052,0,0,1-2.062-.256c-.014-.4,0-.793,0-1.188V22.639c-.13,0-.171.1-.234.166Q24.8,24.4,23.2,26a1.029,1.029,0,0,1-1.117.283,1,1,0,0,1-.7-.837.993.993,0,0,1,.3-.9q2.634-2.638,5.275-5.272a1.015,1.015,0,0,1,1.48,0Q31.076,21.9,33.7,24.544a1.038,1.038,0,0,1,.008,1.482",
    transform: "translate(-11.836 -10.498)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ea457eeea366361c007872e8ececa4ef.svg";
export { ForwardRef as ReactComponent };